export default __webpack_public_path__ + "static/media/unionpay.23031a63.png";